var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Nav',{attrs:{"isShow":_vm.isShow}}),_c('router-view'),_c('Footer',{directives:[{name:"show",rawName:"v-show",value:(!_vm.$route.meta.footerShow),expression:"!$route.meta.footerShow"}],attrs:{"isShow":_vm.isShow}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }